export default [{
    dictKey:'',
    dictValue: '全部'
},{
    dictKey:'0',
    dictValue: '未认证'
},{
    dictKey:'1',
    dictValue: '认证中'
},{
    dictKey:'2',
    dictValue: '已认证'
},{
    dictKey:'3',
    dictValue: '认证失败'
}];



// WEBPACK FOOTER //
// ./src/service/constant/AuthStatus.js